<template><sales-reconciliation-page /></template>
<script>
import SalesReconciliationPage from '../components/SalesReconciliationPage'
export default { name: 'ErpFinanceReconciliation', components: { SalesReconciliationPage } }
</script>
